import React, { useState } from "react";
import procoreLogo from '../../static/procore_logo.png';
import sfdcLogo from '../../static/sfdc-logo.png';
import hubDash from '../../static/hub_logo_arcoblue.png';
import clusterLogo from '../../static/cluster.png';

import GradeIcon from '@mui/icons-material/Grade';
import { Link, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from "@mui/material";
import toast from "react-hot-toast";
import { saveClusterLink } from "../../Containers/api";
import { PROCORE_DOMAIN, SFDC_DOMAIN } from "../../../../utils/config/config";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

// Dev Note: Passing links with noreferrer to help with security. May need to get rid of this if we want ever want analytics on these.

// TODO: Verify Arco_id and hub

const ProjectExternalLinks = ({projectData, selectedProjectId}) => {
    const [showConfirmModal, setShowConfirmModal] = React.useState(false);
    const [clusterLink, setClusterLink] = React.useState("");
    if (!projectData || !projectData.project_data || (!projectData.project_data.procore_id && !projectData.project_data.sfdc_id && !projectData.project_data.arco_id && !selectedProjectId)) {
        return null;
    }

    const procoreURL = `https://${PROCORE_DOMAIN}/projects/${projectData.project_data.procore_id}/budgeting`
    const salesforceURL = `https://${SFDC_DOMAIN}/lightning/r/Opportunity/${projectData.project_data.sfdc_id}/view`
    const hubURL = `${process.env.REACT_APP_HUB_API_DOMAIN_NAME}/project/${selectedProjectId}/`
    const subRatingsURL = `${process.env.REACT_APP_HUB_API_DOMAIN_NAME}/sub-ratings/${selectedProjectId}/`
    const sellSheetsURL = `${process.env.REACT_APP_HUB_API_DOMAIN_NAME}/atlas/?search=${projectData.project_data.arco_id}&hasSellSheet=True/`

    // Send Cost Status Summary Email - Coontrolled by Modal Confirmation Window Now
    const handleDialogOpen = (e) => {
        e.preventDefault(); 
        setClusterLink("");
        setShowConfirmModal(true);
    };
    
    const handleDialogClose = () => {
        setShowConfirmModal(false);
        setClusterLink("");
    };
    
    const saveClusterLinkLocal = async () => {
        // Close the dialog while we process the email
        setShowConfirmModal(false);
        let cluster_id = clusterLink.split("/").filter(Boolean).pop()
    
        try {
            await saveClusterLink(selectedProjectId, cluster_id);
            toast.success("Cost Status Summary email sent successfully!", {
                className: "titillium-web",
            });
        } catch (error) {
            console.error("Error sending cost status email:", error);
            toast.error("Failed to send Cost Status Summary email.", {
                className: "titillium-web",
            });
        }
    };

    return (
        <div className='project-icons-container control-panel' style={{verticalAlign: 'middle'}}>
            <Tooltip title="Open Project Budget in Procore" arrow>
                <Link id="link-1" href={procoreURL} target="_blank" rel="noopener noreferrer" className="control-button">
                        <img src={procoreLogo} className="project-link-icon" alt="Procore" />
                </Link>
            </Tooltip>
            <Tooltip title="Open Project in Salesforce" arrow>
                <Link id="link-2" href={salesforceURL} target="_blank" rel="noopener noreferrer" variant="body2" className="control-button">
                    <img src={sfdcLogo} className="project-link-icon" alt="Salesforce" title="Open in Salesforce"/>
                </Link>
            </Tooltip>
            <Tooltip title="Open Project in ARCO Hub" arrow>
                <Link id="link-3" href={hubURL} target="_blank" rel="noopener noreferrer" variant="body2" className="control-button">
                    <img src={hubDash} className="project-link-icon" alt="Hub Dash" title="Open Hub Project Details"/>
                </Link> 
            </Tooltip>
            <Tooltip title="Open Sub Ratings" arrow>
                <Link id="link-4" href={subRatingsURL} target="_blank" rel="noopener noreferrer" variant="body2" className="control-button">
                    <GradeIcon sx={{fontSize: 'large', color: '#049be5'}} title="Rate Subs" />
                </Link>
            </Tooltip>
            {projectData.project_data.sell_sheets_count === 0 ? (
                <Tooltip title="No Sell Sheets Available" arrow>
                    <div
                        id="link-6"
                        className="control-button"
                        style={{
                            opacity: 0.5,
                            cursor: 'not-allowed'
                        }}
                    >
                        <PictureAsPdfIcon sx={{fontSize: 'large', color: '#9e9e9e'}} title="Sell Sheets Report" />
                    </div>
                </Tooltip>
            ) : (
                <Tooltip title="Access Sell Sheets" arrow>
                    <Link
                        id="link-6"
                        href={sellSheetsURL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="control-button"
                    >
                        <PictureAsPdfIcon 
                            sx={{
                                fontSize: 'large', 
                                color: '#049be5'
                            }} 
                            title="Sell Sheets Report" 
                        />
                    </Link>
                </Tooltip>
            )}

            {projectData.project_data.cluster_id ? (
                <Tooltip title="Cluster Icon" arrow>
                    <Link
                        id="link-5"
                        href={'https://cluster.co/c/'+projectData.project_data.cluster_id+'/'}
                        target="_blank"
                        className="control-button"
                    >
                        <img src={clusterLogo} className="cluster-link-icon" alt="Cluster Icon" title="Cluster"/>
                    </Link>
                </Tooltip>
            ): (
                <Tooltip title="Link Cluster to the Project" arrow>
                    <Link
                        id="link-5"
                        href={'#'}
                        target="_blank"
                        onClick={handleDialogOpen}
                        className="control-button"
                    >
                        <img src={clusterLogo} className="cluster-link-icon" alt="Link Cluster to the Project" title="Cluster"/>
                    </Link>
                </Tooltip>                
            )}
            <Dialog open={showConfirmModal} onClose={handleDialogClose}>
                <DialogTitle className="titillium-web">Add a Cluster Link</DialogTitle>
                <DialogContent className="titillium-web">
                    Please enter the link to the project's Cluster account.
                    <TextField
                        autoFocus
                        margin="dense"
                        id="cluster-url"
                        label="Cluster Link"
                        type="url"
                        fullWidth
                        variant="outlined"
                        value={clusterLink}
                        onChange={(e) => setClusterLink(e.target.value)}
                        placeholder="https://cluster.co/c/your_cluster_id/"
                    />
                </DialogContent>
                <DialogActions>
                <Button className="titillium-web" onClick={handleDialogClose} color="info" variant="outlined">
                    Cancel
                </Button>
                <Button className="titillium-web" onClick={saveClusterLinkLocal} color="primary" variant="contained">
                    Confirm
                </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default ProjectExternalLinks;